import { Box, Button, Grid } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useCallback, useEffect, useState } from "react";
import { ProductSelector } from "../product-selector";
import { ManagedProductStatus } from "domains/allocations/components";
import localisations from "../../localisation";

type ProductSearchProps = {
    fieldCompanyId: number,
    fields: {
        productId: number,
        productDetails: {
            id: number
        }
    },
    handleFieldChange: (fields: any) => void;
    handleSearch: (productDetails: any) => void;
};

function ProductSearch(props: ProductSearchProps) {
    const { handleFieldChange } = props;
    const [productRefresh, setProductRefresh] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [partitionManaged, setPartitionManaged] = useState(true);

    const onProductSelected = useCallback((productDetails) => {
        handleFieldChange({ productDetails: productDetails });
        localStorage.setItem("searchProductDetails", JSON.stringify(productDetails));
        setShowMessage(true)
    }, [handleFieldChange]);

    const handleSearchDetailsChange = () => {
        var productDetails = JSON.parse(localStorage.getItem("searchProductDetails") ?? JSON.stringify({}))
        props.handleSearch(productDetails)
    };

    const onProductStatusLoaded = useCallback((status) => {
        setProductRefresh(false);
        setPartitionManaged(status);
    }, []);

    // Remove search history for page refresh
    useEffect(() => {
        const handleBeforeUnload = (e: any) => {
            localStorage.removeItem("searchProductDetails");
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    return (
        <Box mb={2}>
            <Grid container spacing={2} style={{ minWidth: "100px" }}>
                <Grid item xs={10} md={4}>
                    <ProductSelector
                        smallSize={true}
                        fieldCompanyId={props.fieldCompanyId}
                        initialProductId={JSON.parse(localStorage.getItem("searchProductDetails") ?? JSON.stringify({}))?.id}
                        onSelected={onProductSelected}
                    />
                    {showMessage && (<ManagedProductStatus
                        showUnmanagedProduct={true}
                        productId={props.fields.productDetails?.id ?? null}
                        onLoaded={onProductStatusLoaded}
                        forceRefresh={productRefresh}
                        formatMessage={(status) => status ? "" : localisations.unManagedProduct}
                    />)}
                </Grid>
                <Grid item xs={2} md={8}>
                    <Button disabled={!partitionManaged} id="productsearch-go" variant="contained" color="primary" onClick={() => handleSearchDetailsChange()}>
                        <SearchIcon />
                    </Button>
                </Grid>
            </Grid>
        </Box>

    );
}
export default ProductSearch;